import { render, staticRenderFns } from "./NewHomeSlider.vue?vue&type=template&id=2c377fee&scoped=true&"
import script from "./NewHomeSlider.vue?vue&type=script&lang=js&"
export * from "./NewHomeSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewHomeSlider.vue?vue&type=style&index=0&id=2c377fee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c377fee",
  null
  
)

export default component.exports